import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import { BASE_URL } from 'utils/constants';

const ChatContainer = styled.div`
  margin: 10px;
  padding: 10px;
  max-width: 100%;
  height: 400px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow-y: auto;
`;

// 0 -> mentor  , 1 -> student
const Message = styled.div`
  padding: 8px 12px;
  margin: 5px;
  border-radius: 8px;
  background-color: ${props => props.sentBy === '0' ? '#D6E4FF' : '#E7E7E7'};
`;

const FeedbackBox = styled.div`
  border: 1px solid #e0e0e0;
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  background-color: #f9f9f9;
`;

const MilestoneTitle = styled.h4`
  margin-top: 0;
`;

const StarRating = styled.div`
  color: gold;
  font-size: 20px;
  display: flex;
`;

const InputArea = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
`;

const TextInput = styled.input`
  flex: 1;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
`;

const SendButton = styled.button`
  background-color: #007BFF;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const starMax = 5;

const betterSectionName = name => {

  let newName = name;
  switch (name) {
    case "prototype":
      newName = "Prototype";
      break;

    case "materials":
      newName = "Materials and tools are ready";
      break;

    case "building_prototype":
      newName = "Building Prototype";
      break;

    case "testing_prototype":
      newName = "Testing Prototype";
      break;

    case "itteration":
      newName = "Itteration";
      break;

    case "displayboard":
      newName = "Displayboard";
      break;

    case "project_name":
      newName = "Project Name";
      break;

    case "abstract":
      newName = "Abstract";
      break;

    case "introduction":
      newName = "Introduction";
      break;

    case "acknowledgement":
      newName = "Acknowledgement";
      break;

    case "refrences":
      newName = "Refrences";
      break;

    case "conclusion":
      newName = "Conclusion";
      break;

    case "res_data":
      newName = "Results and data analysis";
      break;

    case "methods_material":
      newName = "Methods and Materials";
      break;

    case "bmc":
      newName = "BMC";
      break;

    case "key_partners":
      newName = "Key Partners";
      break;

    case "key_activities":
      newName = "Key Activities";
      break;

    case "value_proposition":
      newName = "Value Proposition";
      break;

    case "customer_relationship":
      newName = "Customer Relationship";
      break;

    case "customer_segments":
      newName = "Customer Segments";
      break;

    case "key_resources":
      newName = "Key resource ( Hardware tools )";
      break;

    case "channels":
      newName = "Channels";
      break;

    case "revenue_streams":
      newName = "Revenue Streams";
      break;

    case "cost_structure":
      newName = "Cost Structure";
      break;

    case "portfolio":
      newName = "Portfolio";
      break;

    case "sdgs":
      newName = "Sustainable Development Goals (SDGs)";
      break;

    case "identify_problem":
      newName = "Identify the Problem";
      break;

    case "linkable_prototyp":
      newName = "Linkable Prototype";
      break;

    case "research_ideas":
      newName = "Research Ideas";
      break;

    case "selected_solution":
      newName = "Selected Solution";
      break;

    case "criteria_constrains":
      newName = "Criteria and Constrains";
      break;

    case "test_evaluate":
      newName = "Test and Evaluate";
      break;

    case "refine_design":
      newName = "Refine the design";
      break;

    case "learning_outcomes":
      newName = "Learning Outcomes";
      break;

    default:
      break;
  }
  return newName;
}
const Msg = (props) => {
  const [text, setText] = useState("");
  const handleSend = () => {
    if (text?.trim() !== "") {
      // // console.log("globalState?.permissions?.fullname")
      // // console.log(props.globalState?.permissions?.id)
      // globalState?.permissions?.fullname

      Swal.showLoading();
      axios.post(`${BASE_URL}/capstone/feedback/sendmsg.php`, {
        capstonemainmsg_id: props.data.id,
        content: text,
      })
        .then(res => {
          let hasFailedFlag = true
          if (res?.data?.data) {
            const res_data_data = res?.data?.data;
            // console.log("res_data_data")
            // console.log(res_data_data)
            if (res_data_data.hasOwnProperty("user_id")) {
              props.data.users_roles[res_data_data.user_id] = "1";
              if (res_data_data.hasOwnProperty("fullname")) {
                props.data.users[res_data_data.user_id] = res_data_data.fullname;
              }
            }
            if (res_data_data.hasOwnProperty("date")) {
              hasFailedFlag = false
              props.data.messages = [...props?.data?.messages, { content: text, sent_by: props.globalState?.permissions?.id, sent_ts: res_data_data.date }]
              setText("");
            }
            props.setAllMsg(x => [...x])
          }
          if (hasFailedFlag) {
            Swal.fire("Sorry, try again later", "", "error")
          }
          Swal.close();
        }).catch(err => {
          Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

        })


    }
  };


  return (
    <ChatContainer>
      <FeedbackBox>
        <MilestoneTitle>{betterSectionName(props?.data?.main_section)} {" > "} {betterSectionName(props?.data?.sub_section)}</MilestoneTitle>
        <MilestoneTitle>{props?.data?.milestone_title}</MilestoneTitle>
        <p>By: <i>{props?.data?.users?.hasOwnProperty(props?.data?.by) ? props?.data?.users[props?.data?.by] : ""}</i>, At: <i>{props?.data?.creation_ts}</i></p>
        {/* <StarRating>{[0, 0, 0, 0, 0].map((x, i) => (i < props?.data?.star_rating) ? "⭐" : "☆")}</StarRating> */}
        <StarRating>{[0, 0, 0, 0, 0].map((x, i) => (<span
          key={i}
          style={{
            // cursor: "pointer",
            ...((i < props?.data?.star_rating) ? {
              fontSize: "20px",
              padding: "8px 0 2px 0",
            } : {
              fontSize: "30px",
              padding: "0 0 0 2.47px",
            })
          }}
        >
          {(i < props?.data?.star_rating) ? "⭐" : "☆"}
        </span>))}</StarRating>

        <p>{props?.data?.recommendation}</p>
        <p>{props?.data?.references}</p>
      </FeedbackBox>

      {/* Render Messages */}
      {props?.data?.messages?.map((message, index) => (
        <Message key={index} sentBy={props?.data?.users_roles?.hasOwnProperty(props?.data?.by) ? props?.data?.users_roles[message.sent_by] : ""}>
          <div
            className=' d-flex justify-content-between align-content-center '
          >
            <span><i>{props?.data?.users?.hasOwnProperty(props?.data?.by) ? props?.data?.users[message.sent_by] : ""} : </i> {message.content}</span>
            <span> - {message.sent_ts}</span>
          </div>
        </Message>
      ))}

      {/* Input Area */}
      <InputArea>
        <TextInput
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Type your reply..."
        />
        <SendButton onClick={handleSend}>Send</SendButton>
      </InputArea>
    </ChatContainer>
  );
}

const FeedbackEmpty = () => {
  return <div
    id='FeedbackEmpty'
    style={{

      marginTop: "50px",
      textAlign: "center",
      fontSize: "20px",

    }}
  >
    Empty
  </div>

}


const Feedback = () => {
  const globalState = useSelector((state) => state);
  const [allMsg, setAllMsg] = useState([]);

  useEffect(() => {

    Swal.showLoading();
    axios.get(`${BASE_URL}/capstone/feedback/getfeedback.php`)
      .then(res => {
        if (res?.data?.data) {
          const res_data_data = res?.data?.data;
          // console.log(res_data_data)
          if (res_data_data.hasOwnProperty("msgs")) {
            setAllMsg(res_data_data.msgs)
          }
        }
        Swal.close();
      }).catch(err => {
        Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

      })

  }, [])

  return (
    <div id='Feedback'>
      {
        allMsg.length ? allMsg.map(x => <Msg key={x.id} data={x} setAllMsg={setAllMsg} globalState={globalState} />) : <FeedbackEmpty />
      }
    </div>
  );
};

export default Feedback;
